import dynamic from "next/dynamic";

export const Forbidden = dynamic(async () => import("./403").then((module) => module));
